import {
  Card,
  Row,
  Col,
  Typography,
  Button,
  Form,
  InputNumber,
  DatePicker,
  Select,
} from "antd";
import dayjs from "dayjs";

export const ChargesForm = ({ form, editMode, transactionCategories }: any) => {
  return (
    <Card
      style={{
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
        marginBottom: 16,
      }}
      title={
        <Typography.Title level={4}>Charges and Prorations</Typography.Title>
      }
    >
      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <Form.Item label="Charges">
            <Row gutter={[16, 16]}>
              {["Monthly", "One-Time"].map((frequency) => (
                <Col xs={24} sm={12} key={frequency}>
                  <Typography.Text
                    strong
                    style={{ fontSize: 16, marginBottom: 12, display: "block" }}
                  >
                    {frequency} Charges
                  </Typography.Text>
                  <Form.List name="fees">
                    {(fields) => (
                      <>
                        {fields
                          .filter(
                            (field) =>
                              form.getFieldValue(["fees", field.name])
                                .frequency === frequency
                          )
                          .map(({ key, name, ...restField }) => (
                            <Card
                              key={key}
                              style={{
                                marginBottom: 12,
                                border: "1px solid #f0f0f0",
                                borderRadius: 8,
                              }}
                              size="small"
                            >
                              <Row gutter={[16, 16]}>
                                <Col xs={24} sm={12}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "feeType"]}
                                    label="Fee Type"
                                    rules={[
                                      {
                                        required: true,
                                        message: "Fee type is required",
                                      },
                                    ]}
                                  >
                                    <Select
                                      disabled={true}
                                      placeholder="Select fee type"
                                      showSearch
                                      optionFilterProp="label"
                                      options={[...transactionCategories]
                                        .sort((a: any, b: any) => a.Name.localeCompare(b.Name))
                                        .map((category: any) => ({
                                          value: category.ID,
                                          label: `${category.Name}`,
                                        }))}
                                    />
                                  </Form.Item>
                                </Col>
                                <Col xs={24} sm={12}>
                                  <Form.Item
                                    {...restField}
                                    name={[name, "amount"]}
                                    label="Amount"
                                    rules={[
                                      {
                                        required: true,
                                        message: "Amount is required",
                                      },
                                    ]}
                                  >
                                    <InputNumber
                                      disabled={
                                        !editMode
                                      }
                                      prefix="$"
                                      min={0}
                                      style={{ width: "100%" }}
                                      formatter={(value) =>
                                        `${value}`.replace(
                                          /\B(?=(\d{3})+(?!\d))/g,
                                          ","
                                        )
                                      }
                                      parser={(value: any) =>
                                        value?.replace(/\$\s?|(,*)/g, "")
                                      }
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </Card>
                          ))}
                      </>
                    )}
                  </Form.List>
                  {frequency === "Monthly" && (
                    <>
                      <Card
                        style={{
                          marginBottom: 12,
                          border: "1px solid #f0f0f0",
                          borderRadius: 8,
                        }}
                        size="small"
                      >
                        <Row gutter={[16, 16]}>
                          <Col xs={24} sm={12}>
                            <Form.Item label="Fee Type">
                              <Typography.Text
                                style={{
                                  display: "block",
                                  padding: "4px 11px",
                                  background: "#fafafa",
                                  border: "1px solid #d9d9d9",
                                  borderRadius: 6,
                                  lineHeight: "22px",
                                }}
                              >
                                Trash Fee
                              </Typography.Text>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12}>
                            <Form.Item
                              name="trashFee"
                              label="Amount"
                              initialValue={12}
                            >
                              <InputNumber
                                disabled={!editMode}
                                prefix="$"
                                min={0}
                                style={{ width: "100%" }}
                                formatter={(value) =>
                                  `${value}`.replace(
                                    /\B(?=(\d{3})+(?!\d))/g,
                                    ","
                                  )
                                }
                                parser={(value: any) =>
                                  value?.replace(/\$\s?|(,*)/g, "")
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Card>
                      <Card
                        style={{
                          marginBottom: 12,
                          border: "1px solid #f0f0f0",
                          borderRadius: 8,
                        }}
                        size="small"
                      >
                        <Row gutter={[16, 16]}>
                          <Col xs={24} sm={12}>
                            <Form.Item label="Fee Type">
                              <Typography.Text
                                style={{
                                  display: "block",
                                  padding: "4px 11px",
                                  background: "#fafafa",
                                  border: "1px solid #d9d9d9",
                                  borderRadius: 6,
                                  lineHeight: "22px",
                                }}
                              >
                                Tax
                              </Typography.Text>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12}>
                            <Form.Item
                              name="taxFee"
                              label="Amount"
                              initialValue={0}
                            >
                              <InputNumber
                                disabled={!editMode}
                                prefix="$"
                                min={0}
                                style={{ width: "100%" }}
                                formatter={(value) =>
                                  `${value}`.replace(
                                    /\B(?=(\d{3})+(?!\d))/g,
                                    ","
                                  )
                                }
                                parser={(value: any) =>
                                  value?.replace(/\$\s?|(,*)/g, "")
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Card>
                    </>
                  )}
                  {frequency === "One-Time" && (
                    <>
                      <Card
                        style={{
                          marginBottom: 12,
                          border: "1px solid #f0f0f0",
                          borderRadius: 8,
                        }}
                        size="small"
                      >
                        <Row gutter={[16, 16]}>
                          <Col xs={24} sm={12}>
                            <Form.Item label="Fee Type">
                              <Typography.Text
                                style={{
                                  display: "block",
                                  padding: "4px 11px",
                                  background: "#fafafa",
                                  border: "1px solid #d9d9d9",
                                  borderRadius: 6,
                                  lineHeight: "22px",
                                }}
                              >
                                Inspection Fee
                              </Typography.Text>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12}>
                            <Form.Item
                              name="inspectionFee"
                              label="Amount"
                              initialValue={100}
                            >
                              <InputNumber
                                disabled={!editMode}
                                prefix="$"
                                min={0}
                                style={{ width: "100%" }}
                                formatter={(value) =>
                                  `${value}`.replace(
                                    /\B(?=(\d{3})+(?!\d))/g,
                                    ","
                                  )
                                }
                                parser={(value: any) =>
                                  value?.replace(/\$\s?|(,*)/g, "")
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Card>
                      <Card
                        style={{
                          marginBottom: 12,
                          border: "1px solid #f0f0f0",
                          borderRadius: 8,
                        }}
                        size="small"
                      >
                        <Row gutter={[16, 16]}>
                          <Col xs={24} sm={12}>
                            <Form.Item label="Fee Type">
                              <Typography.Text
                                style={{
                                  display: "block",
                                  padding: "4px 11px",
                                  background: "#fafafa",
                                  border: "1px solid #d9d9d9",
                                  borderRadius: 6,
                                  lineHeight: "22px",
                                }}
                              >
                                Parking Permit Replacement Fee
                              </Typography.Text>
                            </Form.Item>
                          </Col>
                          <Col xs={24} sm={12}>
                            <Form.Item
                              name="parkingPermitReplacementFee"
                              label="Amount"
                              initialValue={50}
                            >
                              <InputNumber
                                disabled={!editMode}
                                prefix="$"
                                min={0}
                                style={{ width: "100%" }}
                                formatter={(value) =>
                                  `${value}`.replace(
                                    /\B(?=(\d{3})+(?!\d))/g,
                                    ","
                                  )
                                }
                                parser={(value: any) =>
                                  value?.replace(/\$\s?|(,*)/g, "")
                                }
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Card>
                    </>
                  )}
                </Col>
              ))}
            </Row>
          </Form.Item>
        </Col>
        <Col xs={24}>
          <Form.Item label="Other Fees (Max 2)">
            <Form.List name="otherFees">
              {(fields, { add, remove }) => (
                <>
                  <Row gutter={[16, 16]}>
                    {fields.map(({ key, name, ...restField }) => (
                      <Col xs={24} sm={12} key={key}>
                        <Card
                          style={{
                            marginBottom: 12,
                            border: "1px solid #f0f0f0",
                            borderRadius: 8,
                            padding: 16,
                          }}
                          size="small"
                        >
                          <Row gutter={[16, 16]}>
                            <Col xs={24} sm={12}>
                              <Form.Item
                                {...restField}
                                name={[name, "feeType"]}
                                label="Fee Type"
                                rules={[
                                  {
                                    required: true,
                                    message: "Fee type is required",
                                  },
                                ]}
                              >
                                <Select
                                  disabled={!editMode}
                                  placeholder="Select fee type"
                                  showSearch
                                  optionFilterProp="label"
                                  options={[...transactionCategories]
                                    .sort((a: any, b: any) => a.Name.localeCompare(b.Name))
                                    .map((category: any) => ({
                                      value: category.ID,
                                      label: `${category.Name} (${category.Abbreviation})`,
                                    }))}
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12}>
                              <Form.Item
                                {...restField}
                                name={[name, "frequency"]}
                                label="Frequency"
                                rules={[
                                  {
                                    required: true,
                                    message: "Frequency is required",
                                  },
                                ]}
                              >
                                <Select
                                  disabled={!editMode}
                                  placeholder="Select frequency"
                                  options={[
                                    { value: "Monthly", label: "Monthly" },
                                    { value: "One-Time", label: "One-Time" },
                                  ]}
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12}>
                              <Form.Item
                                {...restField}
                                name={[name, "startDate"]}
                                label="Start Date"
                                rules={[
                                  {
                                    required: true,
                                    message: "Start date is required",
                                  },
                                ]}
                              >
                                <DatePicker
                                  disabled={!editMode}
                                  style={{ width: "100%" }}
                                  format="MMM DD, YYYY"
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12}>
                              <Form.Item
                                {...restField}
                                name={[name, "amount"]}
                                label="Amount"
                                rules={[
                                  {
                                    required: true,
                                    message: "Amount is required",
                                  },
                                ]}
                              >
                                <InputNumber
                                  disabled={!editMode}
                                  prefix="$"
                                  min={0}
                                  style={{ width: "100%" }}
                                  formatter={(value) =>
                                    `${value}`.replace(
                                      /\B(?=(\d{3})+(?!\d))/g,
                                      ","
                                    )
                                  }
                                  parser={(value: any) =>
                                    value?.replace(/\$\s?|(,*)/g, "")
                                  }
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                          <Button
                            danger
                            type="link"
                            onClick={() => remove(name)}
                            style={{ marginTop: 8 }}
                          >
                            Remove Fee
                          </Button>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                  <Form.Item>
                    <Button
                      type="dashed"
                      onClick={() =>
                        add({
                          startDate: dayjs(),
                          frequency: "One-Time",
                          amount: 0,
                        })
                      }
                      block
                      disabled={!editMode || fields.length >= 2}
                    >
                      + Add Other Fee
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </Form.Item>
        </Col>
        <Col xs={24} sm={12}></Col>
      </Row>
    </Card>
  );
};
